/**
 * Root error boundary — the last line of defense against the WHITE BLANK
 * SCREEN. Without it, any uncaught render/lifecycle error unmounts the whole
 * React tree and a POS till shows an empty page with no way back except
 * killing the app (Biryani House sign-out report, 2026-08-02).
 *
 * On catch: log the error + component stack through console.error so it
 * reaches the cloud (app_logs) and the Electron daily file, then show a
 * dark, theme-neutral recovery screen with a one-tap reload.
 */
import React from 'react';

export default class RootErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    try {
      // eslint-disable-next-line no-console
      console.error('[react-crash] uncaught render error', {
        message: String(error?.message || error),
        stack: String(error?.stack || '').slice(0, 1500),
        componentStack: String(info?.componentStack || '').slice(0, 1500),
        hash: typeof window !== 'undefined' ? window.location.hash : '',
      });
    } catch (_) { /* never throw from the boundary itself */ }
  }

  handleReload = () => {
    try {
      window.location.reload();
    } catch (_) { /* ignore */ }
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '1rem',
          background: '#0f1618',
          color: '#f4f7f8',
          fontFamily:
            "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
          padding: '2rem',
          textAlign: 'center',
        }}
      >
        <div style={{ fontSize: '2.4rem' }}>⚠️</div>
        <div style={{ fontSize: '1.15rem', fontWeight: 700 }}>
          Something went wrong / Bir hata oluştu
        </div>
        <div style={{ fontSize: '0.9rem', color: 'rgba(255,255,255,0.55)', maxWidth: '26rem' }}>
          The screen hit an unexpected error. Your orders and data are safe.
          <br />
          Ekran beklenmedik bir hatayla karşılaştı. Siparişleriniz ve verileriniz güvende.
        </div>
        <button
          type="button"
          onClick={this.handleReload}
          style={{
            marginTop: '0.5rem',
            padding: '0.85rem 2.2rem',
            background: 'linear-gradient(135deg, #00838f 0%, #006571 100%)',
            border: 'none',
            borderRadius: '10px',
            color: '#fff',
            fontSize: '1rem',
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          Reload / Yeniden Yükle
        </button>
      </div>
    );
  }
}
